import { Location } from '@angular/common';
import { IfStmt } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { AuthService } from '../../services/auth.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
import { Console } from 'console';
@Component({
  selector: 'app-userdetails',
  templateUrl: './userdetails.component.html',
  styleUrls: ['./userdetails.component.css']
})
export class UserdetailsComponent implements OnInit {
  frmuser: FormGroup;
  selected_User_detail: any = {};
  columnToHide: any = [];
  lstUserDetails = [];
  lstProject: any = [];
  lstRole: any = [];
  lstSubgroup: any = [];
  advanceSearchGridData: any = [];
  allSelected: any;
  SubgroupList: any = [];
  RoleList: any = [];

  userInfo: any = {};

  isDisplaySubgroup: boolean = true;

  @ViewChild('ddlSubgroupselect') ddlSubgroupmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlRoleselect') ddlRolemultiselect: DropdownMultiselectComponent;

  private masterData = [];

  showFilter: boolean = true;
  showCloseIcon: boolean = false;
  recordCount: number;
  queryMessage = "";
  currrentUserId: Number;

  modalReference_queryDetail: any;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private location: Location,
    private encryptdecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) { }

  ngOnInit(): void {
    //console.log('IM : ', this.memorystore.getItem('edit_user_id'));
    this.getAuthorizedData();
    //this.getProjectDetails();
    this.getUserDetail();
    this.getUserAccessDetail();
    this.frmuser = new FormGroup({
      PROJECT_ID: new FormControl(),
      ROLE_ID: new FormControl(),
      SUBGROUP_ID: new FormControl(),
      IS_DEFAULT: new FormControl()
    });
  }

  getAuthorizedData() {
    this.authService.getAuthorizedData().subscribe(data => {

      if (data != null) {
        this.masterData = data;
        const res = this.masterData.map(({ project_id, project_name }) => ({ project_id, project_name }));
        this.lstProject = res.filter(
          (thing, i, arr) => arr.findIndex(t => t.project_id === thing.project_id) === i
        );
      }
      else {
        alert("Records not found.")
      }
    });
  }

  getProjectDetails() {

    this.dataService.getData('user/project_info', null).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.status == true) {
          this.masterData = res.data;
          var projinfo = this.masterData.map(({ project_id, project_name }) => ({ project_id, project_name }));
          this.lstProject = [...new Map(projinfo.map((x) => [x['project_id'], x])).values()];
          //this.lstProject = projinfo.filter((thing, i, arr) => arr.findIndex(t => t.project_id === thing.project_id) === i);
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  get_group_mapping_detail() {

    this.SubgroupList = [];
    const project_id = this.frmuser.get("PROJECT_ID").value;
    const res = this.masterData.map(({ project_id, subgroup_id, subgroup_name }) => ({ project_id, subgroup_id, subgroup_name }));
    this.lstSubgroup = res.filter(o => o.project_id === project_id);
    this.lstSubgroup = this.lstSubgroup.filter(
      (thing, i, arr) => arr.findIndex(t => t.subgroup_id === thing.subgroup_id) === i
    );
    this.lstSubgroup = this.lstSubgroup.filter(p => p.subgroup_id != 0);

    this.lstSubgroup.forEach((element) => {
      this.SubgroupList.push({
        //value: element.subgroup_id,
        text: element.subgroup_name,
        selected: true,
      });
    });

    this.isDisplaySubgroup = (this.SubgroupList.length > 0);

    this.get_role_mapping_detail_project();
  }

  get_role_mapping_detail_project() {

    this.RoleList = [];
    const project_id = this.frmuser.get("PROJECT_ID").value;
    const res = this.masterData.map(({ project_id, role_id, role_name }) => ({ project_id, role_id, role_name }));
    this.lstRole = res.filter(o => o.project_id === project_id).filter(
      (thing, i, arr) => arr.findIndex(t => t.role_id === thing.role_id) === i
    );

    this.lstRole.forEach((element) => {
      this.RoleList.push({
        value: element.role_id,
        text: element.role_name,
        selected: true,
      });
    });


    this.ddlRolemultiselect.allSelected = true;
    this.ddlRolemultiselect.ngAfterViewInit();
  }

  // get_role_mapping_detail() {
  //   const project_id = this.frmuser.get("PROJECT_ID").value;
  //   const subgroup_id = this.frmuser.get("SUBGROUP_ID").value;
  //   const res = this.masterData.map(({ project_id, subgroup_id, role_id, role_name }) => ({ project_id, subgroup_id, role_id, role_name }));
  //   this.lstRole = res.filter(o => o.project_id === project_id && o.subgroup_id == subgroup_id);
  // }

  getUserDetail() {
    let params;
    if(this.memorystore.getItem('edit_user_id') == undefined) //Added by imran on 21-01-2026
    {
      params = 
        {
          editeduserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
        };
    }
    else
    {
        params = 
        {
          // USER_ID: Number(this.commonService.getUserInfoFromLocalStorage('edit_user_id'))
          // USER_ID: Number(this.memorystore.getItem('edit_user_id'))
          editeduserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('edit_user_id')),
          xusrid : this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))//Added by imran on 01-04-26
        };
    }
    this.dataService.postData('user/get_user', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          const formControls: any = {};
          this.userInfo = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getUserAccessDetail() {
    this.advanceSearchGridData = [];
    let params;
    if(this.memorystore.getItem('edit_user_id') == undefined) //Added by imran on 21-01-2026
    {
      params = 
        {
          encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
        };
    }
    else
    {
        params = 
        {
          // USER_ID: Number(this.commonService.getUserInfoFromLocalStorage('edit_user_id'))
          // USER_ID: Number(this.memorystore.getItem('edit_user_id'))
          encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('edit_user_id'))
        };
    }
    this.advanceSearchGridData = [];
    this.dataService.postData('user/get_userdetails', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (
          res != null &&
          res != undefined &&
          res.data != null &&
          res.data.length > 0
        ) {

          let user_details = res.data;
          user_details.forEach((item) => {
            let rowData = {
              user_detail_id: item.USER_DETAIL_ID,
              user_id: item.USER_ID,
              "PROJECT_ID": item.PROJECT_ID,
              "PROJECT": item.PROJECT_NAME,
              //"SUBGROUP_ID": item.SUBGROUP_ID,
              "SUBGROUP": item.SUBGROUP_NAME,
              "ROLE_ID": item.ROLE_ID,
              "ROLE": item.ROLE_NAME,
              "DEFAULT": item.IS_DEFAULT == 1 ? "Yes" : "No",
              "action_icon_Delete": "fa fa-trash",
            };
            this.advanceSearchGridData.push(rowData);

          });
          this.columnToHide.push("user_id");
          this.columnToHide.push("PROJECT_ID");
          this.columnToHide.push("ROLE_ID");
          this.columnToHide.push("SUBGROUP_ID");
          this.columnToHide.push("user_detail_id");
          this.columnToHide.push("SUBGROUP");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

      // if (this.advanceSearchGridData.length <= 0) {
      //   this.commonService.showMessageBox('No data found', 'Information');
      // }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  User_Details_grid_CellClick(event: any) {


    // var rowEditData = this.advanceSearchGridData.filter((item) => item.user_id == event.rowData.user_id);
    // if (rowEditData != undefined) {
    //   this.selected_User_detail = rowEditData[0];
    //   if (event.columnName == "action_icon_Delete") {
    //     this.deleteUser_Detail_GridRowConfirmationdialog();
    //   }
    // }
    if (event.rowData != undefined) {
      this.selected_User_detail = event.rowData;
      if (event.columnName == "action_icon_Delete") {
        this.deleteUser_Detail_GridRowConfirmationdialog();
      }
    }
  }

  deleteUser_Detail_GridRowConfirmationdialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: "Alert",
        message: "Are you sure want to delete ?",
        messageBoxType: "question",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.delete_user_detail();

      }
      else {
        this.selected_User_detail = {};
      }
    });
  }

  addRoles() {

    let selectedSubgroups: any = [];
    let selectedRoles: any = [];

    if (this.isDisplaySubgroup) {
      this.ddlSubgroupmultiselect.onDropdownOptionClick();
      selectedSubgroups = this.ddlSubgroupmultiselect.selectedValues;
    }


    this.ddlRolemultiselect.onDropdownOptionClick();
    selectedRoles = this.ddlRolemultiselect.selectedValues;

    let validationStatus: boolean = true;
    let validationMessage: string = '';

    validationMessage += '- Please fill the required field(s).\r <br/>';
    if (this.frmuser.get("PROJECT_ID").value == null) {
      validationMessage += '- Please select Project.\r <br/>';
      validationStatus = false;
    }
    else if (this.frmuser.get("PROJECT_ID").value.length <= 0) {
      validationMessage += '- Please enter Project.\r <br/>';
      validationStatus = false;
    }
    // if (this.lstSubgroup.length > 0) {
    //   if (selectedSubgroups.length <= 0) {
    //     validationMessage += '- Select  one Subgroup.\r <br/>';
    //     validationStatus = false;
    //   }
    //}
    if (selectedRoles.length <= 0) {
      validationMessage += '- Select Role.\r <br/>';
      validationStatus = false;
    }

    if (!validationStatus) {
      this.commonService.showMessageBox(validationMessage, 'Alert');
      return;
    }


    let SUBGROUP_ID: number = 0;
    let ROLE_ID: number = 0;
    let ROLE_NAME: string = "";

    let lstRole: USER_ROLE[] = [];

    let lstSubGroup = [];

    if (selectedRoles.length > 0) {
      selectedRoles.forEach(async element => {
        lstRole.push({ ROLE_ID: Number(element), ROLE_NAME: this.RoleList.find(x => Number(x.value) == element).text });
      });

      if (selectedSubgroups != undefined && selectedSubgroups.length > 0) {
        selectedSubgroups.forEach(async element => {
          lstSubGroup.push(Number(element));
        });
      }

      this.AddRecord(lstRole, lstSubGroup);
    }


    // if (selectedRoles.length > 0) {
    //   if (this.lstSubgroup.length == 0) {
    //     selectedRoles.forEach(async element => {
    //       ROLE_ID = element;
    //       ROLE_NAME = this.RoleList.find(x => Number(x.value) == ROLE_ID).text;
    //       await this.AddRecord(ROLE_ID, SUBGROUP_ID, ROLE_NAME);
    //     });
    //   }
    //   else {
    //     selectedSubgroups.forEach(element => {
    //       let SUBGROUP_ID: number = element;
    //       selectedRoles.forEach(async childelement => {
    //         ROLE_ID = childelement;
    //         ROLE_NAME = this.RoleList.find(x => Number(x.value) == ROLE_ID).text;
    //         await this.AddRecord(ROLE_ID, SUBGROUP_ID, ROLE_NAME);
    //       });
    //     });
    //   }
    // }
  }

  async AddRecord(ROLE_ID: USER_ROLE[], SUBGROUP_ID: number[]) {
    let body = {
      // // USER_ID: Number(this.commonService.getUserInfoFromLocalStorage('edit_user_id')),
      // USER_ID: Number(this.memorystore.getItem('edit_user_id')),
      // PROJECT_ID: this.frmuser.get("PROJECT_ID").value,
      // ROLE_LIST: ROLE_ID,
      // //SUBGROUP_LIST: SUBGROUP_ID,
      // IS_DEFAULT: this.frmuser.get("IS_DEFAULT").value ? 1 : 0,
      // // CREATED_BY: (this.commonService.getUserInfoFromLocalStorage("userId"))
      // CREATED_BY: (this.memorystore.getItem("userId"))
      encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('edit_user_id')),
      PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.frmuser.get("PROJECT_ID").value),
      ROLE_LIST: ROLE_ID,
      IS_DEFAULT: this.frmuser.get("IS_DEFAULT").value ? 1 : 0,
      CREATEDBY: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem("userId")),
     xusrid:this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };
 
    this.dataService.postData("user/add_userdetail", body).subscribe(res => {
      if (res.status == true) {
        if (res.error_message != "") {
          this.commonService.showMessageBox(res.error_message, "Message", "error");
        } else {
          this.getUserAccessDetail();
          this.reset();
          this.commonService.showMessageBox("Role(s) Added Successfully", "Message");
        }
      }
      else if (res.error_message != null) {
        if (res != null)
          this.commonService.showMessageBox(res.error_message, "Message", "error");
        else
          this.commonService.showMessageBox("Something went wront.", "error");
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    }, error => {
      this.commonService.showMessageBox(error.toString());
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
    // err => {
    //   this.commonService.showMessageBox(err.toString());
    // });
 
  }
  // async AddRecord(ROLE_ID, SUBGROUP_ID, ROLE_NAME) {
  //   let body = {
  //     USER_ID: Number(this.commonService.getUserInfoFromLocalStorage('edit_user_id')),
  //     PROJECT_ID: this.frmuser.get("PROJECT_ID").value,
  //     ROLE_ID: ROLE_ID,
  //     SUBGROUP_ID: SUBGROUP_ID,
  //     IS_DEFAULT: this.frmuser.get("IS_DEFAULT").value ? 1 : 0,
  //     CREATED_BY: (this.commonService.getUserInfoFromLocalStorage("userId"))
  //   };


  //   await this.dataService.postDataPromise("user/add_userdetail", body).then(res => {

  //     if (res != null && res.status == true) {
  //       if (res.data == undefined || res.data == null) {
  //         this.commonService.showMessageBox("The  role " + ROLE_NAME + " is already assigned.", "Message", "error");
  //       }
  //       else {
  //         this.recordCount = res.data.length;
  //         if (this.recordCount == 0) {
  //           this.commonService.showMessageBox("No record found.", "Message", "error");
  //         }
  //         else {
  //           this.getUserAccessDetail();
  //           this.reset();
  //         }
  //       }
  //     }
  //     else {
  //       if (res != null)
  //         this.commonService.showMessageBox(res.errorMessage, "Message", "error");
  //       else
  //         this.commonService.showMessageBox("Something went wront.", "error");
  //     }

  //   }).catch(err => {
  //     this.commonService.showMessageBox(err.toString());
  //   });

  // }

  reset() {
    this.frmuser.get('PROJECT_ID').setValue('');
    this.frmuser.get('IS_DEFAULT').setValue(0);

    this.isDisplaySubgroup = true;

    if (this.ddlSubgroupmultiselect != undefined) {
      this.ddlSubgroupmultiselect.allSelected = true;
      this.ddlSubgroupmultiselect.ngAfterViewInit();
    }

    if (this.ddlRolemultiselect != undefined) {
      this.ddlRolemultiselect.allSelected = true;
      this.ddlRolemultiselect.ngAfterViewInit();
    }

    // this.RoleList = [];
    // this.SubgroupList = [];
  }

  delete_user_detail() {
    let param = {
      // USER_DETAIL_ID: this.selected_User_detail.user_detail_id,
      // // CHANGED_BY: Number(this.commonService.getUserInfoFromLocalStorage("userId"))
      // CHANGED_BY: Number(this.memorystore.getItem("userId"))
      USERDETAILID: this.encryptdecryptservice.encryptUsingAES256(this.selected_User_detail.user_detail_id),
      // CHANGED_BY: Number(this.commonService.getUserInfoFromLocalStorage("userId"))
      CHANGEDBY: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem("userId")),
      xusrid:this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    }

    this.dataService.postData("user/delete_userdetail", param).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.status == true) {
          this.selected_User_detail = {};
          this.commonService.showMessageBox("Deleted successfully.", "Message");
          this.getUserAccessDetail();
        }
        else {
          this.commonService.showMessageBox("Record could not be deleted.", "Message");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  back() {
    this.location.back();
  }
}

export class USER_ROLE {
  ROLE_ID: number;
  ROLE_NAME: string;
}